.grid {
  width: 100%;
}

.search {
  margin-top: 8px;
  margin-bottom: 8px;
}

.commandSelect {
  margin-left: 8px;
}
